module.exports = __webpack_public_path__ + "img/bg_rocket_launch_1920_1.22490a43.png";